<template>
    <div class="flex items-items justify-between font-bold text-sm lg:text-md py-2 lg:py-3 first:pt-0 last:pb-0 text-gray-700">
        <span><slot name="name" /></span>
        <span><slot /></span>
    </div>
</template>
